module.exports = __webpack_public_path__ + "img/cancel.12fb5ce.png";